<template>
    <div class="d-flex justify-content-end bg-dark-blue text-white" style="padding: 10px 30px;">
        <h4 class="mr-3">Preview:</h4>
        <div class="switch-wrapper">

            <div class="switch" v-on:click="$emit('toggleEdit')">
                <input type="checkbox" name="preview-toggle" v-model="previewEnabled" />
                <span class="slider round"></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EditSwitch",
        props: ["tab", "edit"],
        data: function() {
            return {
                selectedTab: this.tab,
                editEnabled: this.edit,
            }
        },
        computed: {
            previewEnabled() {
                return !this.editEnabled;
            }
        },
        watch: {
            tab: function (newVal, oldVal) {
                this.selectedTab = newVal;
            },
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            },
        },
        methods: {
        },
    }
</script>